import constants from '../helpers/constants.js';
import _ from 'lodash';
import { MDTApi } from '../services/mdtapi.js';
import { MDTApp } from '../actions/bootAction.js';

export const NotificationListStore = {
    init,
    getNotificationCount
};


function init() {
    return (dispatch, getState) => {
        let store = getState().notification;

        if (store.init) {
            return;
        }


        dispatch(updateNotificationInit(true));
        
        dispatch(getNotificationCount());



    }
}

function updateNotificationInit(data) {
    return { type: constants.USER_NOTIFICATION_INIT, data };
}

function updateNotificationCount(data) {
    return { type: constants.USER_NOTIFICATION_COUNT, data };
}

function getNotificationCount() {
    return (dispatch, getState) => {
        let appId = MDTApp.getSetting('appid');
        let customerId = getState().meDetails.customerId;

        unreadNotifications(appId, customerId).then(data => {
            dispatch(updateNotificationCount(data));

        }).catch(error => {
            throw (error);
        });
    }
}

function unreadNotifications(appId, customerId) {

    var data = {
        bu: MDTSetting.pathVars.buid,
        history: false
    };

    // Customer filtering
    if (customerId) {
        data.customer = customerId;
    }

    // Application filtering
    if (appId) {
        data.app = appId;
        data.allAppNotification = false;
    } else {
        data.allAppNotification = true;
    }

    return MDTApi.call('api.notifications.count', {
        params: data,
        method: 'GET'
    });

}